import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './shared/App';

// import './shared/providers/miragejs';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
